import request from '@/utils/request'

export function getJobList(job_name, job_code) {
    return request({
        url: '/web/job/getJobList',
        method: 'post',
        data: {
            job_name: job_name,
            job_code: job_code
        }
    })
}

export function getJobSurvey(job_code) {
    return request({
        url: '/web/job/getJobSurvey',
        method: 'post',
        data: {
            job_code: job_code,
        }
    })
}

export function getPositionDetail(id) {
    return request({
        url: '/web/job/getPositionDetail',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getJobCategory() {
    return request({
        url: '/web/job/getJobCategory',
        method: 'post',
        data: {
        }
    })
}

export function getIndustrySalary() {
    return request({
        url: '/web/job/getIndustrySalary',
        method: 'post',
        data: {
        }
    })
}